var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPathGatsby(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2648_2425)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2648_2425)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60 0C26.8608 0 0 26.8608 0 60C0 93.1392 26.8608 120 60 120C93.1392 120 120 93.1392 120 60C120 26.8608 93.1392 0 60 0ZM12.8928 60.624L59.376 107.107C33.8496 106.776 13.224 86.1504 12.8928 60.624ZM70.5456 105.931L14.0688 49.4544C18.8592 28.512 37.6032 12.8832 60 12.8832C75.6528 12.8832 89.5248 20.52 98.0928 32.2704L91.5696 38.0256C84.6192 28.0608 73.0704 21.5376 60 21.5376C43.3584 21.5376 29.184 32.1072 23.8272 46.9008L73.0992 96.168C85.0656 91.8336 94.2672 81.7344 97.3488 69.2256H76.9296V60H107.122C107.117 82.3968 91.488 101.141 70.5456 105.931Z",
    fill: "#744C9E"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2648_2425"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2648_2425"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPathGatsby);
export default __webpack_public_path__ + "static/media/path-gatsby.08c250502311d38cc0c4e74e141edfb7.svg";
export { ForwardRef as ReactComponent };